function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M207.626 263.106l.018-.017.02-.016c10.107-7.919 17.47-14.753 22.111-20.505 4.794-5.941 8.693-13.763 11.682-23.484 7.797-29.482-9.002-65.613-42.134-87.898-19.781-13.305-41.992-19.387-61.893-18.227-19.899 1.159-37.462 9.553-48.029 25.174-1.287 1.904-2.732 4.669-4.244 7.563l-.147.282c-1.556 2.978-3.178 6.061-4.74 8.37-10.566 15.621-11.79 35.003-5.414 53.835 6.376 18.834 20.35 37.091 40.132 50.396 18.707 12.583 40.035 19.005 59.906 18.313 8.381-.292 15.764-2.426 22.178-5.936 4.373-2.393 7.338-4.753 10.554-7.85z",
  fill: "#000",
  stroke: "#000"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M201.843 255.355c-9.156 5.278-37.942 6.454-62.526-5.684-22.81-11.262-41.633-35.054-47.012-51.089-6.333-18.878-.57-44.242 2.235-51.089-3.504 2.771-5.023 8.264-7.582 12.033-17.95 26.443-3.46 67.343 32.364 91.353 17.652 11.831 37.19 17.353 54.617 16.748 15.403-.535 19.4-4.068 22.168-6.724 3.262-3.13 5.174-4.979 5.736-5.548z",
  fill: "#DAE2EB"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M130.128 235.168c-35.442-24.123-49.777-65.214-32.018-91.781 17.758-26.567 60.886-28.548 96.329-4.426 35.442 24.122 49.777 65.214 32.018 91.781-17.758 26.566-60.886 28.548-96.329 4.426z",
  fill: "#DAE2EB"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M130.128 235.168c-35.442-24.123-49.777-65.214-32.018-91.781 17.758-26.567 60.886-28.548 96.329-4.426 35.442 24.122 49.777 65.214 32.018 91.781-17.758 26.566-60.886 28.548-96.329 4.426z",
  fill: "#DAE2EB"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M221.38 236.951c-20.455 17.937-57.224 16.879-88.114-4.196-35.194-24.013-49.429-64.917-31.794-91.363a43.487 43.487 0 013.148-4.159 43.549 43.549 0 00-7.54 8.602c-17.635 26.446-3.4 67.35 31.794 91.363 33.249 22.685 73.31 22.178 92.506-.247z",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M112.467 142.92c18.453-14.662 50.121-12.065 75.813 7.667 29.272 22.482 39.703 58.693 23.298 80.881a37.976 37.976 0 01-2.903 3.472 37.78 37.78 0 006.892-7.134c16.405-22.188 5.974-58.4-23.298-80.881-27.655-21.24-62.232-22.626-79.802-4.005z",
  fill: "#fff"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M137.551 224.855c12.321 8.537 25.732 13.256 38.277 14.265-12.29-2.292-25.023-8.205-36.382-17.647-14.154-11.765-23.525-26.808-27.222-41.634-3.696-14.825-1.723-29.471 6.876-40.372a37.953 37.953 0 016.016-6.073c-5.882 3.019-10.872 7.343-14.555 12.95-7.427 11.302-8.169 25.728-3.298 39.951 4.871 14.223 15.347 28.207 30.288 38.56z",
  fill: "#000",
  stroke: "#000"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M150.311 160.682l-.32-.384-.384.32-15.177 12.645-6.593-7.904 24.742-20.614 38.74 46.445c1.509 1.809 2.737 4.039 3.271 6.426l.002.009.002.008c1.041 4.005.353 8.46-1.747 12.256l-.004.007-.004.007-7.587 14.84-9.704-6.618 5.493-11.051.002-.004c1.831-3.509 1.546-7.692-.971-10.709l-29.761-35.679z",
  fill: "#000",
  stroke: "#000"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M149.643 150.356l-24.009 20.003 6.942 8.323 14.646-12.203 28.56 34.24c2.281 2.735 2.584 6.513.955 9.683l-3.998 7.16 10.058 6.935 6.007-10.849c2.01-3.689 2.646-8.049 1.587-12.002-.548-2.365-1.775-4.567-3.262-6.35l-37.486-44.94z",
  fill: "#DAE2EB"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M174.02 218.452l-3.18-2.105 4.334-7.355c1.774-3.252 1.599-7.048-.632-9.723l-27.934-33.488-15.377 12.813-2.591-3.107 18.006-15.002 30.378 36.418c1.205 1.445 2.167 3.257 2.536 5.236.74 3.302-.002 7.023-1.899 10.237l-3.641 6.076z",
  fill: "#fff"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M286.035 87.447c0 48.018-39.025 86.947-87.168 86.947-48.142 0-87.168-38.929-87.168-86.947S150.725.5 198.867.5c48.143 0 87.168 38.929 87.168 86.947z",
  fill: "#000",
  stroke: "#000"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M198.867 164.147c42.483 0 76.923-34.34 76.923-76.7s-34.44-76.699-76.923-76.699c-42.483 0-76.923 34.34-76.923 76.7 0 42.359 34.44 76.699 76.923 76.699z",
  fill: "#DAE2EB"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M122.071 92.333a78.846 78.846 0 01-.127-4.47c0-42.59 34.44-77.115 76.923-77.115 42.483 0 76.923 34.525 76.923 77.114 0 1.5-.043 2.991-.127 4.47-2.31-40.508-35.809-72.643-76.796-72.643-40.987 0-74.486 32.135-76.796 72.644z",
  fill: "#fff"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M128.118 65.04c17.136-36.85 59.914-53.503 97.094-38.562-35.509-9.709-73.881 7.319-89.962 41.9-16.08 34.579-4.424 74.997 25.816 96.033-35.311-18.958-50.084-62.522-32.948-99.37z",
  fill: "#000",
  stroke: "#000"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M175.922 163.323l-22.981-5.894c-3.874-6.362-6.324-15.403-7.398-25.71-1.084-10.391-.765-22.028.873-33.419 1.639-11.391 4.595-22.521 8.776-31.902 4.185-9.39 9.577-16.983 16.061-21.362 26.79-18.092 62.573-11.82 79.936 13.951a54.54 54.54 0 015.015 9.253 55.778 55.778 0 00-1.96-3.127c-8.92-13.24-25.418-16.308-39.444-11.817-14.037 4.495-25.747 16.606-25.049 33.87 1.011 25.01-5.706 39.505-10.962 50.103l-.612 1.233c-2.363 4.746-4.379 8.796-5.075 12.717-.705 3.974-.056 7.801 2.82 12.104z",
  fill: "#000",
  stroke: "#000"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M259.46 73.768c.372 1.111.714 2.24 1.024 3.385 8.824 32.512-10.718 65.93-43.648 74.642-32.929 8.711-66.777-10.583-75.601-43.095a61.033 61.033 0 01-1.22-5.48c10.182 30.452 42.807 48.115 74.577 39.71 31.081-8.222 50.235-38.456 44.868-69.162z",
  fill: "#fff"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M211.078 61.61v-.5H190.82V50.82h32.211v60.466c0 2.355-.486 4.854-1.605 7.029l-.004.008-.004.008c-1.766 3.742-5.149 6.724-9.194 8.295l-.008.003-.007.003-15.337 6.543-3.212-11.293 11.299-4.973.004-.002c3.654-1.523 6.115-4.919 6.115-8.847V61.61z",
  fill: "#000",
  stroke: "#000"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M217.181 53.25h-31.258v10.835h19.068v44.577c0 3.56-2.189 6.656-5.471 8.049l-7.658 2.94 3.282 11.764 11.566-4.489c3.907-1.548 7.189-4.489 8.908-8.203 1.094-2.167 1.563-4.644 1.563-6.966V53.25z",
  fill: "#DAE2EB"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M192.277 121.155l-1.094-3.653 8.041-2.876c3.446-1.362 5.744-4.39 5.744-7.872V63.155h-20.021v-4.044h23.444v47.414c0 1.881-.422 3.888-1.407 5.644-1.547 3.01-4.501 5.394-8.018 6.648l-6.689 2.338z",
  fill: "#fff"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M36.22 173.046l-.018-.018-.02-.016c-10.107-7.919-17.47-14.753-22.111-20.505-4.794-5.941-8.693-13.763-11.682-23.484-7.797-29.482 9.002-65.612 42.134-87.898 19.781-13.305 41.992-19.387 61.893-18.227 19.899 1.16 37.462 9.553 48.029 25.174 1.288 1.905 2.732 4.67 4.244 7.564l.147.281c1.556 2.978 3.178 6.062 4.74 8.37 10.566 15.622 11.791 35.004 5.415 53.835-6.377 18.834-20.352 37.092-40.132 50.397-18.708 12.583-40.036 19.005-59.907 18.312-8.381-.292-15.764-2.426-22.178-5.936-4.373-2.392-7.337-4.752-10.554-7.849z",
  fill: "#000",
  stroke: "#000"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M42.003 165.295c9.156 5.278 37.942 6.454 62.526-5.684 22.81-11.261 41.633-35.053 47.012-51.089 6.333-18.877.569-44.241-2.235-51.088 3.504 2.77 5.023 8.263 7.582 12.032 17.95 26.443 3.46 67.343-32.364 91.353-17.652 11.831-37.19 17.353-54.617 16.748-15.403-.534-19.4-4.068-22.168-6.723-3.262-3.13-5.174-4.98-5.736-5.549z",
  fill: "#DAE2EB"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M113.718 145.108c35.442-24.122 49.777-65.214 32.018-91.78-17.759-26.567-60.887-28.549-96.329-4.426C13.965 73.024-.37 114.115 17.39 140.682c17.758 26.567 60.886 28.548 96.329 4.426z",
  fill: "#DAE2EB"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M113.718 145.108c35.442-24.122 49.777-65.214 32.018-91.78-17.759-26.567-60.887-28.549-96.329-4.426C13.965 73.024-.37 114.115 17.39 140.682c17.758 26.567 60.886 28.548 96.329 4.426z",
  fill: "#DAE2EB"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.466 146.891c20.455 17.938 57.224 16.88 88.114-4.196 35.194-24.012 49.429-64.917 31.794-91.362a43.412 43.412 0 00-3.148-4.16 43.568 43.568 0 017.541 8.603c17.634 26.445 3.399 67.35-31.795 91.362-33.25 22.686-73.31 22.179-92.506-.247z",
  fill: "#fff"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M131.379 52.86c-18.454-14.662-50.12-12.066-75.813 7.666-29.272 22.482-39.703 58.694-23.298 80.881a37.798 37.798 0 002.903 3.473 37.754 37.754 0 01-6.892-7.135c-16.405-22.188-5.974-58.4 23.298-80.881 27.655-21.24 62.232-22.626 79.802-4.004z",
  fill: "#fff"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M106.295 134.794c-12.321 8.537-25.732 13.256-38.277 14.265 12.29-2.292 25.023-8.205 36.382-17.646 14.154-11.766 23.526-26.808 27.222-41.634 3.696-14.825 1.723-29.471-6.876-40.372a37.943 37.943 0 00-6.015-6.073c5.881 3.019 10.871 7.343 14.555 12.949 7.426 11.302 8.168 25.728 3.297 39.952-4.871 14.223-15.347 28.207-30.288 38.559z",
  fill: "#000",
  stroke: "#000"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M65.404 100.4l25.961-26.91.428-.443-.522-.328-12.664-7.945.789-4.715 6.425-2.094 29.257 11.625 2.058 6.226L71.499 123.6c-1.773 1.856-4.06 3.444-6.627 4.265l-.007.002-.007.002c-4.256 1.499-9.248 1.045-13.717-1.095l-13.034-6.681v-6.313l5.35-4.232 8.654 4.144.01.005.01.004c.251.106.45.185.599.233.071.023.149.045.223.057a.71.71 0 00.15.01.55.55 0 00.302-.108.52.52 0 00.203-.457.565.565 0 00-.079-.242.967.967 0 00-.149-.183 4.533 4.533 0 00-.362-.308 44.46 44.46 0 00-.835-.635l-.37-.277a54.84 54.84 0 01-1.61-1.249c-1.138-.922-2.277-1.951-2.964-2.899-.345-.476-.545-.89-.601-1.228a.865.865 0 01.055-.529c2.9.945 5.805 1.42 8.714 1.42 3.212 0 6.542-2.412 9.997-6.906z",
  fill: "#000",
  stroke: "#000"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M115.751 69.103l-31.867-18.51-7.78 7.586L95.11 70.266l-33.788 34.483c-2.699 2.754-6.99 3.331-10.949 1.652l-8.935-4.278-5.785 11.436 13.312 6.823c4.57 2.191 9.704 2.669 14.105 1.119 2.661-.851 5.017-2.491 6.837-4.396l45.844-48z",
  fill: "#DAE2EB"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M39.072 115.796l.854-1.687 11.984 5.731c5.31 2.249 11.066 1.477 14.685-2.213l45.318-46.197-25.49-16.192 1.757-1.713 29.036 16.716L71.1 118.1c-1.83 1.899-4.2 3.534-6.877 4.382-4.427 1.545-9.591 1.069-14.189-1.115l-10.962-5.57z",
  fill: "#fff"
});

var SvgCreatorTokens = function SvgCreatorTokens(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 278,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29);
};

export default __webpack_public_path__ + "static/creator-tokens.0fe041a7.svg";
export { SvgCreatorTokens as ReactComponent };